import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { getImageUrl } from '@/api/client';

const DEFAULT_BG = 'https://images.pexels.com/photos/8792982/pexels-photo-8792982.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1300&w=940';

// Shared split-screen layout for Login & Register
export const AuthLayout = ({ heading, subtitle, children }) => {
  const [bg, setBg] = useState(DEFAULT_BG);

  useEffect(() => {
    api.get('/public/branding')
      .then(r => { if (r.data?.auth_image_url) setBg(getImageUrl(r.data.auth_image_url)); })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#0A0A0A' }}>
      {/* ── Left panel: gallery artwork image ── */}
      <div className="hidden lg:flex flex-col relative overflow-hidden" style={{ width: '58%', flexShrink: 0 }}>
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${bg}')`, filter: 'brightness(0.55)' }}
          data-testid="auth-bg-image"
        />
        <div
          className="absolute inset-0"
          style={{ background: 'linear-gradient(to top, rgba(10,10,10,0.85) 0%, rgba(10,10,10,0.15) 50%, rgba(10,10,10,0.40) 100%)' }}
        />
        <div className="relative z-10 p-10">
          <Link to="/" className="inline-block">
            <span style={{ fontFamily: 'var(--font-serif)', fontSize: '1.25rem', fontWeight: 600, color: '#F5F0E8', letterSpacing: '-0.01em' }}>
              The Listing Room
            </span>
          </Link>
        </div>
        <div className="relative z-10 mt-auto p-10 pb-14">
          <p className="text-xs uppercase tracking-widest mb-4" style={{ color: 'rgba(255,255,255,0.7)' }}>Exclusive Art Marketplace</p>
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 'clamp(2rem, 3.5vw, 2.8rem)', fontWeight: 600, color: '#F5F0E8', lineHeight: 1.2, maxWidth: '420px', marginBottom: '1.25rem' }}>
            A curated room<br />for exceptional art.
          </h1>
          <p style={{ color: 'rgba(245,240,232,0.65)', fontSize: '0.875rem', maxWidth: '360px', lineHeight: 1.7 }}>
            Members-only access to verified sellers, original works, and a private enquiry channel.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <div style={{ width: '32px', height: '1px', backgroundColor: 'rgba(255,255,255,0.7)' }} />
            <span style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.7)', letterSpacing: '0.15em', textTransform: 'uppercase' }}>Est. 2024</span>
          </div>
        </div>
      </div>

      {/* ── Right panel: form ── */}
      <div className="flex-1 flex flex-col items-center justify-center px-8 py-12" style={{ backgroundColor: '#FDFCFA', minHeight: '100vh' }}>
        <div className="lg:hidden mb-8 text-center">
          <Link to="/">
            <span style={{ fontFamily: 'var(--font-serif)', fontSize: '1.2rem', fontWeight: 600, color: 'var(--text)' }}>The Listing Room</span>
          </Link>
        </div>

        <div style={{ width: '100%', maxWidth: '400px' }}>
          <div className="mb-8">
            <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '1.75rem', fontWeight: 600, color: 'var(--text)', lineHeight: 1.2 }}>{heading}</h2>
            {subtitle && <p className="mt-1.5 text-sm" style={{ color: 'var(--text-muted)' }}>{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
